/**
 * Which terms a hotel agreed to, and when they last changed.
 *
 * A date rather than a number: what somebody agreed to is a question about
 * when, and an operator comparing a tenant's stored version against this one
 * can see at a glance whether they have been asked since the last revision.
 *
 * Bump this whenever the terms themselves change, so acceptance recorded
 * before the change cannot be mistaken for acceptance of what came after.
 */
export const TERMS_VERSION = '2026-08-28';
/** The company the hotel is contracting with. */
export const TERMS_COMPANY = 'Europium Solutions Pvt Ltd';
export const TERMS_CONTACT_URL = 'https://www.europiumsolutions.com/contact-us/';
//# sourceMappingURL=terms.js.map